import { useTranslation } from 'react-i18next';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useAuth } from '@/contexts/UnifiedAuthContext';
import { useProfile } from '@/hooks/useProfile';

const CURRENCIES = [
  { value: 'RUB', labelKey: 'balance.currency.rub' },
  { value: 'USD', labelKey: 'balance.currency.usd' },
  { value: 'EUR', labelKey: 'balance.currency.eur' },
] as const;

const CurrencySelector = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const { profile, updateCurrency } = useProfile(user?.id);

  const currentCurrency = profile?.currency || 'RUB';

  const handleChange = (value: string) => {
    updateCurrency(value);
  };

  return (
    <div className="flex items-center gap-2">
      <span className="text-sm text-muted-foreground whitespace-nowrap">
        {t('balance.currency.label')}
      </span>
      <Select value={currentCurrency} onValueChange={handleChange}>
        <SelectTrigger className="w-[180px]">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {CURRENCIES.map((currency) => (
            <SelectItem key={currency.value} value={currency.value}>
              {t(currency.labelKey)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default CurrencySelector;
